import React, { useState, useEffect } from 'react';

import { useSelector, useDispatch } from 'react-redux';

import { InputMask } from 'primereact/inputmask';
import EnjoyHint from "xbs-enjoyhint/src/enjoyhint.js"

import '../../static/css/main.css'
import '../../static/fonts/stylesheet.css'
import { selectEmail, selectPhone, setEmail, setPhone, setProcessCalc, setStepCalc } from './calcSlice';
import { addVisitor, confirmEmail, sendCode } from './calcApi';


let timer_sms
let seconds = 10

export function Contacts() {
    const dispath = useDispatch()
    const email = useSelector(selectEmail)

    const [showFormConfirmEmail, setShowFormConfirmEmail] = useState(false)
    const [codeEmail, setCodeEmail] = useState('');
    const [emptyEmail, setEmptyEmail] = useState(false);
    const [correctPhone, setCorrectPhone] = useState(true);
    const [showInfoSend, setShowInfoSend] = useState(false);
    const [showPopUpChangePhone, setShowPopUpChangePhone] = useState(false);

    const [emptyData, setEmptyData] = useState(true);

    const [time_wait, setTime_wait] = useState(0);

    const phone = useSelector(selectPhone)
    const [phoneL, setPhoneL] = useState(phone);

    const handleClickPhone = () => {
        setShowPopUpChangePhone(true)
    }

    const handleChangeEmail = (e) => {
        checkEmail(e.target.value)
        dispath(setEmail(e.target.value))
    }

    const handleChangeCodeEmail = (e) => {
        setCodeEmail(e.target.value)
    }

    const handleChangePhone = (e) => {
        // dispath(setPhone(e.target.value))
        setCorrectPhone(true)
        // console.log('handleChangePhone', e.target.value.replace(/\D/g, ""))
        setPhoneL(e.target.value)
    }

    const handleClickConfirmEmail = () => {

        if (checkEmail(email) && checkPhone(phoneL)) {

            timer_sms = setInterval(() => {
                setTime_wait(seconds)
                seconds = seconds - 1
                // console.log('sec ', seconds)
                if (seconds === 0) {
                    console.log('sec 0')
                    clearInterval(timer_sms)
                    setTime_wait(0)
                    seconds = 10
                }
            }, 1000)

            setShowInfoSend(true)
            window.ym(90426649, 'reachGoal', 'tel-push')
            confirmEmail({ email: email, phone: phoneL }, function (data) {
                // console.log('handleClickConfirmEmail', data)
                if (data.res) {
                    setShowFormConfirmEmail(true)
                }
            })


        }
    }

    const checkEmail = (email) => {
        if (email.replaceAll(' ', '') === "") {
            setEmptyEmail(true)
            return false
        } else {
            setEmptyEmail(false)
            return true
        }
    }

    const checkPhone = (phoneL) => {
        if (phoneL.replace(/\D/g, "").length !== 11) {
            setCorrectPhone(false)
            return false
        } else {
            setCorrectPhone(true)
            return true
        }
    }

    const handleClickNext = () => {
        if (phone) {
            dispath(setProcessCalc('data_person'))
            dispath(setStepCalc('data_person'))
            return
        }
        sendCode({ email: email, code: codeEmail }, function (data) {
            if (data.res) {
                dispath(setPhone(phoneL))
                // alert('Почта верна')
                // setShowFormConfirmEmail(false)
                if (checkEmail(email))
                    dispath(setProcessCalc('data_person'))
                dispath(setStepCalc('data_person'))
                window.ym(90426649, 'reachGoal', 'tel-ok')
            }
            else {
                alert('Неверный код')
                // setShowFormConfirmEmail(false)
            }
        })

    }

    const handleClickYesChangePhoneNumber = () => {
        setShowPopUpChangePhone(false)
        setShowFormConfirmEmail(false)
    }

    const handleChangeData = () => {
        // console.log('handleChangeData', phone)
        setEmptyData(true)
        setPhoneL('')
        dispath(setEmail(''))
        dispath(setPhone(''))
    }

    function hint2() {
        console.log('hint2')
        var enjoyhint_instance = new EnjoyHint({});

        //simple config. 
        //Only one step - highlighting(with description) "New" button 
        //hide EnjoyHint after a click on the button.
        var enjoyhint_script_steps = [
            {
                'next .hint11': 'Введите ваш мобильный телефон. Не волнуйтесь, мы не передаём ваш номер третьим лицам. Это требование страховых компаний, чтобы они могли оформить полис.'
            },
            {
                "next .hint12": "Введите ваш адрес электронной почты. На него будет отправлена копия страхового полиса. ",
            },
            {
                "next .hint13": `После заполнения полей "Мобильный телефон" и "Адрес электронной почты", нажмите кнопку "Подтвердить телефон". Вам придёт код подтверждения на телефон и электронную почту. `
            },
            {
                "next .hint14": `Введите код, который пришёл на ваш мобильный телефон. Если код не пришёл на телефон, проверьте вашу электронную почту.`
            },
            {
                "next .hint15": `После ввода кода нажмите кнопку "Подтвердить код", чтобы перейти к следующему шагу и завершить оформление полиса.`
            }

        ];

        //set script config
        enjoyhint_instance.set(enjoyhint_script_steps);

        //run Enjoyhint script
        enjoyhint_instance.run();
    }

    const popup =
        <div className='popup_question'>
            <div>Вы хотите изменить номер телефона?</div>
            <div className='cur-p' onClick={handleClickYesChangePhoneNumber}>Да</div>
            <div className='cur-p' onClick={() => setShowPopUpChangePhone(false)}>Нет</div>
        </div>

    // useEffect(() => {
    //     setTimeout(() => hint2(), 500)
    // }, []);

    useEffect(() => {
        setShowInfoSend(false)
        // console.log('useEffect', phone)
        if (phone) {
            setEmptyData(false)
            setPhoneL(phone)
        }
        return () => {
            clearInterval(timer_sms)
        }
    }, []);

    return (
        <>
            <div class="calculator-tab-body-blok calculator-tab-body-blok-1 p-r">
                {showPopUpChangePhone && popup}
                <p class="calculator-tab-body-blok-title calculator-tab-body-blok-title-1">
                    Контактная информация
                </p>
                <p class="calculator-tab-body-blok-title calculator-tab-body-blok-title-11">
                    Контактная информация
                </p>

                <div class="tab-body-blok-info tab-body-blok-info-1" id="tab-body-blok-info-1">
                    <div
                        class="tab-body-blok-info-row tab-body-blok-info-row-6 tab-body-blok-info-row-66">
                        <div class="tab-body-blok-info-element tab-body-blok-info-element-210 hint11">
                            <div class={"tab-body-blok-info-element-vnutr " + (correctPhone ? "" : "redBorder")}>
                                <label class="section-two-banks-text-2" for="pet-select">
                                    Мобильный телефон
                                </label>
                                {!showFormConfirmEmail ?
                                    <InputMask mask="+7(999) 999-9999"
                                        placeholder="+7(___) ___-____"
                                        className="pole pole-step-2 mask-phone "
                                        value={phoneL}
                                        onChange={handleChangePhone}
                                    /> :
                                    <div onClick={handleClickPhone} className='pole pole-step-2 mask-phone txt_a_l'>
                                        {phoneL}
                                    </div>
                                }
                            </div>
                        </div>
                        {!showFormConfirmEmail &&
                            <a class="button button-1 button-novostroiki-1 button-step-210 hint13" href="#!"
                                name="button"
                                onClick={emptyData ? handleClickConfirmEmail : handleChangeData}
                            >
                                {!phone ? 'Подтвердить телефон' : 'Изменить телефон'}
                            </a>
                        }
                        {showFormConfirmEmail &&
                            <div class="tab-body-blok-info-element tab-body-blok-info-element-220 p-r">
                                <div
                                    class="tab-body-blok-info-element-vnutr tab-body-blok-info-element-vnutr-chek hint14">
                                    <img class="pole-2-chek" src="img/icon-checked.svg" alt="chek" />
                                    <label class="section-two-banks-text-2" for="pet-select">
                                        Код подтверждения
                                    </label>
                                    <input class="pole pole-step-2 pole-2 mask-kod " id="pole-2"
                                        name="kod" type="text"
                                        value={codeEmail}
                                        onChange={handleChangeCodeEmail}
                                        onkeyup="success2()"
                                        placeholder="----" />
                                </div>
                                <div className='cntr_btn_repeat_sms_desk'>
                                    {time_wait !== 0 && <div className='txt_send_sms'>Повторить отправку можно через {time_wait}</div>}
                                    {time_wait === 0 && <div onClick={handleClickConfirmEmail} className='txt_send_sms cur-p'>Повторить</div>}
                                </div>
                            </div>
                        }

                    </div>
                    <div className='cntr_btn_repeat_sms_mobil'>
                        {time_wait !== 0 && <div className='txt_send_sms'>Повторить отправку можно через {time_wait}</div>}
                        {time_wait === 0 && <div onClick={handleClickConfirmEmail} className='txt_send_sms cur-p'>Повторить</div>}
                    </div>
                    <div class="tab-body-blok-info-row tab-body-blok-info-row-7">
                        <div class="tab-body-blok-info-element tab-body-blok-info-element-23 hint12">
                            <div class={"tab-body-blok-info-element-vnutr " + (!emptyEmail ? "" : "redBorder")}>
                                <label class="section-two-banks-text-2" for="pet-select">
                                    Адрес электронной почты
                                </label>
                                {/* <input class="pole pole-step-2 mask-phone form-control" id="pole-1.23"
                                    name="telefon" type="phone"
                                    value={phone} onChange={handleChangePhone}
                                    onkeyup="success2()"
                                    placeholder="+7 (___) ___ __ __" 
                                /> */}
                                <input
                                    class="pole pole-step-2" id="pole-1.21" name="email" type="email"
                                    value={email}
                                    onChange={handleChangeEmail}
                                    onkeyup="success2()" placeholder="ivan@mail.ru"
                                />

                            </div>
                        </div>
                        <div class="checkbox-box">
                            <input class="checkbox-1" type="checkbox" id="zakon" name="zakon" value=""
                                onkeyup="displaySubmit()" checked />
                            <label for="scales">Нажимая кнопку «Далее», я подтверждаю свою
                                дееспособность, принимаю Правила страхования и подтверждаю свое согласие
                                на обработку персональных данных в соответствии с Федеральным законом №
                                152-ФЗ «О персональных данных» от 27.06.2006 г.</label>
                        </div>

                    </div>
                    <div type="submit" class="button button-1 button-novostroiki-1 button-step-23 hint15"
                        id="button-step-23" value="Далее" disabled
                        onClick={handleClickNext}
                    >
                        Далее
                    </div>

                    {emptyEmail &&
                        <div class="validacia-2">
                            <p id="validacia-text"
                                class="tab-body-blok-info-animation-text tab-body-blok-info-animation-text-2 tab-body-blok-info-animation-text-22 tab-body-blok-info-element-400-text">
                                Укажите ваш e-mail, он нужен для получения вашего полиса
                            </p>
                        </div>
                    }
                    {!correctPhone &&
                        <div class="validacia-2">
                            <p id="validacia-text"
                                class="tab-body-blok-info-animation-text tab-body-blok-info-animation-text-2 tab-body-blok-info-animation-text-22 tab-body-blok-info-element-400-text">
                                Укажите корректный телефон
                            </p>
                        </div>
                    }
                    {showInfoSend &&
                        <div class="validacia-2">
                            <p id="validacia-text" style={{ color: 'green' }}
                                class="tab-body-blok-info-animation-text tab-body-blok-info-animation-text-2 tab-body-blok-info-animation-text-25 tab-body-blok-info-element-400-text">
                                Код направлен на ваш телефон и почту
                            </p>
                        </div>
                    }
                </div>

            </div>
        </>
    );
}



